import React, { useEffect, useState } from "react";
import { SingleCardMetric } from "../ui/SingleCardMetric";

interface PeopleServedMetricProps {
  data: any;
  title: string;
  subtitle?: string;
  tooltip?: string;
}

export const PeopleServedMetric = ({ data, title, subtitle = "", tooltip = "" }: PeopleServedMetricProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    setIsLoading(false);
  }, [data]);

  const value = data;
  const display = value === undefined || value === null ? "—" : value.toString();

  return <SingleCardMetric title={title} subtitle={subtitle} tooltip={tooltip} total={display} isLoading={isLoading} />;
};
